import { isNull } from 'lodash'
import type { Description } from '../../schemas'

const LOAD_SOURCE_PRIORITY = ['lhip'] as readonly string[]

const groupByLanguage = (
  data: Description[]
): Record<string, Description[]> => {
  const grouped: Record<string, Description[]> = {}

  for (const description of data) {
    grouped[description.lang] ??= []
    grouped[description.lang]!.push(description)
  }

  return grouped
}

export const deduplicateDescriptionArray = (
  data: Description[] | null
): Description[] | null => {
  if (!data) {
    return null
  }
  const descriptionsGroupedByLanguage = groupByLanguage(data)

  const deduplicatedDescriptionsGroups = Object.values(
    descriptionsGroupedByLanguage
  ).map((descriptionsLanguageGroup) => deduplicate(descriptionsLanguageGroup))

  return deduplicatedDescriptionsGroups
    .flat()
    .filter((descriptionGroup) => !isNull(descriptionGroup))
}

const deduplicate = (
  descriptionArray: Description[] | null
): Description[] | null => {
  const map: Record<string, Description> = {}
  if (!descriptionArray) {
    return null
  }

  for (const description of descriptionArray) {
    const existingEntry = map[description.descriptionId]
    if (!existingEntry || shouldReplace(existingEntry, description)) {
      map[description.descriptionId] = description
    }
  }

  return Object.values(map)
}

const shouldReplace = (
  current: Description,
  incoming: Description
): boolean => {
  const currentIndex = LOAD_SOURCE_PRIORITY.indexOf(current.loadSource ?? '')
  const incomingIndex = LOAD_SOURCE_PRIORITY.indexOf(incoming.loadSource ?? '')

  if (currentIndex !== -1 && incomingIndex !== -1) {
    return incomingIndex < currentIndex
  }

  if (currentIndex === -1 && incomingIndex !== -1) {
    return true
  }

  return false
}
